import Component from './Redirect.vue';

export default {
  install(Vue) {
    Vue.component('BkfRedirect', Component);
  },
};
